import { useRouter } from 'fitify-ui-onboarding/src/hooks/useRouter'
import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { PAGES_CACHE } from 'fitify-ui-onboarding/src/utils/navigation'
import { useMemo } from 'react'
import { styled } from 'styled-components'

import { getPrefetchRoutes } from 'components/RoutePrefetch/RoutePrefetch.Utils'
import { getRouteVideos } from 'components/RoutePrefetch/RouteVideosPrefetch.Utils'
import { useFunnel } from 'hooks/useFunnel'
import { useCategoryVideoVariant } from 'hooks/useVideoProps'

const StyledHiddenVideo = styled.video`
  position: fixed;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`

export const RouteVideosPrefetch = () => {
  const funnel = useFunnel()
  const router = useRouter()
  const variant = useCategoryVideoVariant(funnel)
  const growthBook = useGrowthBook()

  const videoSrcs = useMemo<string[]>(() => {
    if (!funnel) {
      return []
    }

    const routes = getPrefetchRoutes(PAGES_CACHE, router.resolvedPathname)

    return routes.reduce<string[]>((acc, route) => {
      const videoDefinitions = getRouteVideos(route, funnel, variant)
      videoDefinitions.forEach(({ src, prefetchCondition }) => {
        if (!prefetchCondition || prefetchCondition(growthBook)) {
          acc.push(src)
        }
      })
      return acc
    }, [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [funnel, growthBook, router.isReady, router.resolvedPathname, variant])

  return (
    <>
      {videoSrcs.map((src) => (
        <StyledHiddenVideo key={src} preload="auto" muted>
          <source src={src} type="video/webm" />
        </StyledHiddenVideo>
      ))}
    </>
  )
}
